module.exports = __webpack_public_path__ + "img/w3_circle_black.2f41c3d7.png";